export const personalInfo = {
  name: "Rajib Roy",
  avatar: "https://storage.googleapis.com/portfolio-d71e2.firebasestorage.app/profile.jpg",
  title: "Technical Lead | Full Stack Developer & Automation Architect",
  tagline: "Bridging Enterprise Engineering with Intelligent Automation",
  bio: "Technical Lead based in Toronto with 7+ years of experience architecting enterprise automation ecosystems, fraud validation platforms, and distributed microservices testing frameworks. Currently pursuing M.Tech in Artificial Intelligence at IISc Bengaluru. I build AI-powered developer tools, intelligent validation engines, and production-grade ML systems that bridge research with real-world deployment.",
  location: "Toronto, ON, Canada",
  email: "bboyrajib@gmail.com",
  phone: "+1 416 827 3313",
  github: "https://github.com/bboyrajib",
  linkedin: "https://linkedin.com/in/rajib-roy",
  resume: "https://storage.googleapis.com/portfolio-d71e2.firebasestorage.app/RajibRoy.pdf",
  roles: [
    "Technical Lead",
    "Automation Architect",
    "Full-Stack Platform Builder",
    "AI Systems Engineer",
    "Cloud & DevOps Engineer"
  ]
};

export const skills = [
  {
    category: "Backend & Distributed Systems",
    icon: "server",
    color: "primary",
    items: [
      { name: "Java", level: 90 },
      { name: "Node.js", level: 82 },
      { name: "REST / API Design", level: 90 },
      { name: "Microservices Architecture", level: 88 },
      { name: "SQL / NoSQL Databases", level: 86 },
      { name: "Firebase / Serverless", level: 82 }
    ]
  },
  {
    category: "Frontend & Product Engineering",
    icon: "smartphone",
    color: "accent",
    items: [
      { name: "React.js", level: 85 },
      { name: "React Native / Expo", level: 78 },
      { name: "Android (Native)", level: 75 },
      { name: "Tailwind CSS", level: 82 }
    ]
  },
  {
    category: "Cloud, DevOps & CI/CD",
    icon: "cloud",
    color: "secondary",
    items: [
      { name: "Docker", level: 88 },
      { name: "Kubernetes", level: 82 },
      { name: "Azure DevOps", level: 85 },
      { name: "Cloud Run", level: 80 },
      { name: "CI/CD Architecture", level: 90 }
    ]
  },
    {
    category: "AI Systems & Machine Learning",
    icon: "cpu",
    color: "primary",
    items: [
      { name: "Python", level: 92 },
      { name: "PyTorch", level: 85 },
      { name: "FAISS / Vector Search", level: 82 },
      { name: "Clustering & Classical ML", level: 85 },
      { name: "Feature Engineering", level: 88 },
      { name: "LLMs / Generative AI", level: 84 },
      { name: "ML Prototyping (Streamlit)", level: 88 }
    ]
  },
  {
    category: "Automation & Quality Engineering",
    icon: "shield",
    color: "secondary",
    items: [
      { name: "Selenium", level: 92 },
      { name: "Fraud Systems Validation", level: 90 },
      { name: "ETL & Data Integrity Testing", level: 88 },
      { name: "API Validation Frameworks", level: 92 },
      { name: "Observability & Reporting (Power BI)", level: 82 }
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "BuildResume — Cloud Resume SaaS",
    subtitle: "Full-Stack Production Platform",
    description: "Production-grade LaTeX resume builder with real-time compilation and cross-platform support.",
    longDescription: "Designed and deployed a full-stack SaaS platform with Monaco Editor-powered LaTeX editing, real-time PDF rendering, Firebase authentication, Firestore multi-tenant data storage, Docker containerization, and serverless deployment via Google Cloud Run. Supports professional templates and mobile access via Expo.",
    tech: ["React", "Node.js", "Firebase", "Docker", "Cloud Run", "Monaco Editor"],
    color: "primary",
    liveUrl: "https://buildresume.cv",
    githubUrl: "#",
    image: "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?w=1200&q=80",
    featured: true,
    stats: { deployment: "Cloud Run" }
  },
  {
    id: 2,
    title: "Voice Authentication System",
    subtitle: "Deep Learning Speaker Verification",
    description: "Biometric speaker verification using neural embedding extraction and MFCC features.",
    longDescription: "Built a deep neural architecture for text-independent speaker verification using MFCC feature extraction and LSTM-based embedding models. Achieved high accuracy and low EER. Deployed as an interactive Streamlit application for real-time inference and testing.",
    tech: ["PyTorch", "MFCC", "LSTM", "Streamlit", "Librosa"],
    color: "accent",
    liveUrl: "https://voice-auth-325986069329.northamerica-northeast1.run.app/",
    githubUrl: "https://github.com/bboyrajib/voice-auth",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200&q=80",
    featured: true,
    stats: { accuracy: "98%", deployment: "Streamlit" }
  },
  {
    id: 3,
    title: "Forge — AI Agent Orchestration System",
    subtitle: "Multi-Agent LLM Execution Framework",
    description: "Agent-based AI workflow engine supporting multi-model execution, run tracking, and cost monitoring.",
    longDescription: "Designed a modular agent orchestration framework enabling execution across multiple Anthropic models. Implemented run dashboards, budget tracking, Git-based file validation, and execution sandboxing. Built to support scalable AI automation workflows with model abstraction and token management.",
    tech: ["Node.js", "React", "LLMs", "Agent Architecture", "Git Integration"],
    color: "secondary",
    liveUrl: "#",
    githubUrl: "https://github.com/bboyrajib/forge",
    image: "https://images.unsplash.com/photo-1677442135136-760c813028c0?w=1200&q=80",
    featured: true,
    stats: { models: 3, architecture: "Agent-Based" }
  },
  {
    id: 4,
    title: "CodeConverse — Chat With Your Docs",
    subtitle: "RAG-Based Developer Assistant",
    description: "Document-aware AI assistant enabling contextual conversations over repositories and files.",
    longDescription: "Built a Retrieval-Augmented Generation (RAG) system with semantic chunking, vector embeddings, and contextual retrieval. Enables conversational querying over documentation and codebases. Designed for developer productivity and internal knowledge intelligence systems.",
    tech: ["RAG", "Embeddings", "Vector DB", "LLMs", "Streamlit"],
    color: "primary",
    liveUrl: "#",
    githubUrl: "https://github.com/bboyrajib/CodeConverse",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80",
    featured: true,
    stats: { architecture: "RAG", retrieval: "Semantic Search" }
  },
  {
    id: 5,
    title: "AI Music Discovery Platform",
    subtitle: "Vector Search + Behavioral Feedback Loop",
    description: "Scalable recommendation system leveraging FAISS indexing and interaction tracking.",
    longDescription: "Built a multi-model recommendation architecture using FAISS for high-speed vector similarity search. Implemented feature-based, genre-clustered, and artist-similarity models. Roadmap: build behavioral signal tracking (skip, half-play, full-play), design backend microservices ready for client integration and adaptive retraining.",
    tech: ["Python", "FAISS", "Clustering", "Node.js", "Firebase"],
    color: "secondary",
    liveUrl: "#",
    githubUrl: "https://github.com/bboyrajib/music-recommendation-engine/tree/version2",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&q=80",
    featured: true,
    stats: { models: 3, indexing: "Vector Search" }
  },
  {
    id: 6,
    title: "YouTube Live Stream Platform",
    subtitle: "Real-Time Interactive Music System",
    description: "Custom live streaming web platform with dynamic queue management.",
    longDescription: "Built an interactive YouTube-based live streaming system with dynamic playlist queue reordering.",
    tech: ["React", "FFMPEG", "Python"],
    color: "primary",
    liveUrl: "#",
    githubUrl: "https://github.com/bboyrajib/yt-live-stream",
    image: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8eW91dHViZXxlbnwwfHwwfHx8MA%3D%3D",
    featured: true,
    stats: { mode: "Live Streaming", system: "FFMPEG and Queue Engine" }
  },
  {
    id: 7,
    title: "Generative AI QA Platform",
    subtitle: "Enterprise LLM Automation Engine",
    description: "LLM-powered story-to-test automation integrated with enterprise DevOps pipelines.",
    longDescription: "Architected an enterprise automation platform leveraging large language models for automated test case generation from user stories. Implemented RAG-based contextual pipelines and DevOps integrations (Jira, Azure DevOps). Designed for scalable QA intelligence across distributed teams.",
    tech: ["LLMs", "RAG", "Azure DevOps", "Jira", "Python"],
    color: "secondary",
    liveUrl: "#",
    githubUrl: "#",
    image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=1200&q=80",
    featured: false,
    stats: { integration: "Enterprise" }
  }
];

export const appShowcase = [
  {
    id: 1,
    title: "BuildResume",
    description: "Cloud-native LaTeX resume builder with real-time PDF compilation",
    type: "Live SaaS",
    tech: ["React", "Firebase", "Cloud Run"],
    liveUrl: "https://buildresume.cv",
    githubUrl: "#",
    badge: "Live Product",
    color: "secondary",
    icon: "file-text"
  },
  {
    id: 2,
    title: "Voice Authentication Demo",
    description: "Deep learning speaker verification system",
    type: "AI Demo",
    tech: ["PyTorch", "Classical ML", "Deep Learning", "Streamlit"],
    liveUrl: "https://voice-auth-325986069329.northamerica-northeast1.run.app/",
    githubUrl: "https://github.com/bboyrajib/voice-auth",
    badge: "Live Demo",
    color: "accent",
    icon: "mic"
  },
  {
    id: 3,
    title: "Pneumonia Detection Demo",
    description: "CNN-based X-ray classification with Grad-CAM explainability",
    type: "Medical AI Demo",
    tech: ["ResNet50", "Streamlit"],
    liveUrl: "https://automatic-pneumonia-prediction.streamlit.app/",
    githubUrl: "https://github.com/bboyrajib/pneumonia-prediction-streamlit",
    badge: "Live Demo",
    color: "primary",
    icon: "activity"
  },
  {
    id: 4,
    title: "CodeConverse",
    description: "Chat with your codebase using RAG-powered semantic retrieval",
    type: "AI Platform (Beta)",
    tech: ["RAG", "Embeddings", "Vector Search"],
    liveUrl: "#",
    githubUrl: "https://github.com/bboyrajib/CodeConverse",
    badge: "Private Beta",
    color: "accent",
    icon: "messages-square"
  }

];

export const experience = [
  {
    id: 1,
    role: "Technical Lead",
    company: "Wipro Canada",
    client: "Bank – Fraud Detect Platform",
    period: "Mar 2024 – Present",
    type: "work",
    description: "Designing and implementing automated validation systems for fraud event processing across distributed microservices. Built enterprise Power BI dashboards for API health monitoring.",
    highlights: [
      "Automated end-to-end fraud event workflows for source-to-target transformations",
      "Built reusable validation components for fraud rules and decision engine outputs",
      "Integrated CI/CD pipelines with fraud automation suites",
      "Designed Power BI dashboards for real-time API health monitoring"
    ],
    tech: ["Java", "Python", "Power BI", "CI/CD", "Microservices", "Azure DevOps"]
  },
  {
    id: 2,
    role: "Technical Lead",
    company: "Wipro Limited",
    client: "Retail + GenAI Platform",
    period: "Dec 2022 – Mar 2024",
    type: "work",
    description: "Led architectural decisions for enterprise test automation while architecting Wipro's GenAI QA platform powered by LLMs.",
    highlights: [
      "Designed GenAI platform leveraging LLMs for story-to-test creation",
      "Automated complex REST/SOAP integration patterns at scale",
      "Mentored engineers and led code reviews across distributed teams",
      "Evaluated LLM technologies and guided architectural decisions"
    ],
    tech: ["LLMs", "GenAI", "ETAF", "SeaLights", "EggPlant", "JIRA"]
  },
  {
    id: 3,
    role: "Senior Project Engineer",
    company: "Wipro Limited",
    client: "Insurance – Software Quality Governance",
    period: "Dec 2020 – Dec 2022",
    type: "work",
    description: "Implemented quality governance tooling across 7 enterprise applications. Led DevOps containerization and Kubernetes orchestration initiatives.",
    highlights: [
      "Implemented SeaLights quality governance across 7 applications",
      "Built Azure DevOps CI/CD pipelines from scratch",
      "Managed Docker containers using Kubernetes/Rancher",
      "Executed AI/ML POCs across BFSI, Health, Energy verticals"
    ],
    tech: ["Docker", "Kubernetes", "Azure DevOps", "Rancher", "SeaLights"]
  },
  {
    id: 4,
    role: "Project Engineer",
    company: "Wipro Limited",
    client: "Insurance",
    period: "Jun 2018 – Dec 2020",
    type: "work",
    description: "Built self-healing test automation frameworks and pioneered AI-powered test execution using Functionize/VAE across multiple enterprise clients.",
    highlights: [
      "Built Selenium-Java library with Healenium for self-healing locators",
      "Automated Salesforce testing with AI-powered Functionize",
      "Implemented Galen framework for CSS visual validation",
      "Authored comprehensive test plans and automation strategies"
    ],
    tech: ["Java", "Selenium", "Healenium", "Katalon", "Functionize", "TestNG"]
  },
  {
    id: 5,
    role: "M.Tech, Artificial Intelligence",
    company: "Indian Institute of Science",
    client: "Bengaluru, India",
    period: "2024 – Dec 2026",
    type: "education",
    description: "Advanced studies in AI/ML at one of India's premier research institutions. Focus on deep learning, NLP, and applied ML systems.",
    highlights: [
      "Specializing in Deep Learning & Neural Networks",
      "Research focus: Voice Biometrics & Classification Systems",
      "Working on LLM fine-tuning and RAG architectures"
    ],
    tech: ["Deep Learning", "NLP", "Computer Vision", "Reinforcement Learning"]
  },
  {
    id: 6,
    role: "B.Tech, Electrical Engineering",
    company: "NIT Durgapur",
    client: "West Bengal, India",
    period: "2014 – 2018",
    type: "education",
    description: "Bachelor's in Electrical Engineering with First Class honors. GPA: 7.99/10. Strong foundation in signal processing, and control systems.",
    highlights: [
      "First Class Honours | GPA: 7.99/10",
      "Focus: Signal Processing, Control Systems",
      "Final Year Project: IoT-based Smart Grid monitoring"
    ],
    tech: ["Signal Processing", "MATLAB", "Embedded C", "Circuit Design"]
  },
  {
    id: 7,
    role: "Senior Secondary (ISC) — Class XII",
    company: "Don Bosco High & Technical School",
    client: "Kolkata, India",
    period: "2014",
    type: "education",
    description: "Completed Senior Secondary education (ISC board) with an exceptional score of 96.25%, demonstrating strong academic performance in Physics, Chemistry, and Mathematics.",
    highlights: [
      "Score: 96.25% — ISC Board",
      "Subjects: Physics, Chemistry, Mathematics, Biology, English",
      "Ranked among top students in school"
    ],
    tech: ["Physics", "Mathematics", "Chemistry"]
  },
  {
    id: 8,
    role: "Secondary (ICSE) — Class X",
    company: "St. Aloysius High School",
    client: "Kolkata, India",
    period: "2012",
    type: "education",
    description: "Completed Secondary education (ICSE board) with a stellar score of 96.80%, building a strong foundation in sciences and mathematics.",
    highlights: [
      "Score: 96.80% — ICSE Board",
      "Consistent academic excellence throughout schooling",
      "Strong foundation in analytical thinking and sciences"
    ],
    tech: ["Mathematics", "Sciences", "English"]
  }
];

export const achievements = [
  {
    id: 1,
    title: "GenAI QA Platform Architect",
    issuer: "Wipro Innovation Award",
    year: "2023",
    description: "Designed and delivered Wipro's first LLM-powered QA automation platform, reducing test authoring time by 65%.",
    icon: "award",
    color: "primary"
  },
  {
    id: 2,
    title: "MTech AI – IISc Bengaluru",
    issuer: "Indian Institute of Science",
    year: "2024–2026",
    description: "Pursuing advanced AI/ML research at India's #1 research university, focusing on deep learning and voice systems.",
    icon: "graduation-cap",
    color: "secondary"
  },
  {
    id: 3,
    title: "B.Tech First Class Honours",
    issuer: "NIT Durgapur | GPA: 7.99",
    year: "2018",
    description: "Graduated with First Class honours from one of India's top National Institutes of Technology.",
    icon: "star",
    color: "accent"
  },
  {
    id: 4,
    title: "Fraud Automation",
    issuer: "Wipro Canada | Production",
    year: "2024",
    description: "Delivered end-to-end automation to one of the major banks in Canada across their fraud detection platform, serving millions of transactions daily.",
    icon: "shield",
    color: "primary"
  },
  {
    id: 5,
    title: "7+ Years Engineering Excellence",
    issuer: "Wipro Limited",
    year: "2018–Present",
    description: "Consistent performance across Technical Lead roles for major banks, retail and insurance clients.",
    icon: "trending-up",
    color: "secondary"
  },
  {
    id: 6,
    title: "SeaLights at Scale",
    issuer: "7 Enterprise Applications",
    year: "2021",
    description: "Successfully implemented software quality governance tooling (SeaLights) across 7 enterprise-grade applications at an inusrance org.",
    icon: "layers",
    color: "accent"
  }
];
